import React, { useEffect, useRef } from 'react';

// Tiny toast that auto-dismisses. Used for "coming soon" nudges & feedback.
// `onDone` is stored in a ref so the auto-dismiss timer isn't reset every
// time the parent re-renders (which passes a new inline callback identity).
// The countdown only restarts when the message actually changes.
export default function Toast({ msg, onDone, ms = 2600 }) {
  const onDoneRef = useRef(onDone);
  useEffect(() => { onDoneRef.current = onDone; }, [onDone]);
  useEffect(() => {
    const t = setTimeout(() => onDoneRef.current && onDoneRef.current(), ms);
    return () => clearTimeout(t);
  }, [msg, ms]);
  return (
    <div className="toast-wrap" data-testid="toast">
      <div className="toast-card">{msg}</div>
    </div>
  );
}
